<template>
  <div class="role-record">
    <a-spin :spinning="spinning">
      <div class="role-record-title">角色授权记录</div>
      <div class="serach-warp">
        <a-input placeholder="被授权用户" v-model="form.userName" style="width: 200px; margin-right: 15px;" allowClear />
        <a-input placeholder="操作人" v-model="form.operatorName" style="width: 200px; margin-right: 15px;" allowClear />
        <a-date-picker placeholder="授权开始时间" v-model="form.startTime" style="margin-right: 15px;" />
        <a-date-picker placeholder="授权结束时间" v-model="form.endTime" style="margin-right: 15px;" />
        <a-button type="primary" class="search-btn" @click="onSearch">查询</a-button>
        <a-button style="margin-left: 8px;" @click="onReset">重置</a-button>
      </div>
      <role-authorize-record-table ref="recordTable" />
    </a-spin>
  </div>
</template>

<script>
import RoleAuthorizeRecordTable from './childComps/RoleAuthorizeRecordTable'

export default {
  name: 'RoleAuthorizeRecord',
  components: { RoleAuthorizeRecordTable },
  data() {
    return {
      spinning: false,
      form: {
        userName: '',
        operatorName: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  methods: {
    onSearch() {
      this.$refs.recordTable.onSearch(this.normalize())
    },
    onReset() {
      this.form = { userName: '', operatorName: '', startTime: '', endTime: '' }
      this.$refs.recordTable.onSearch({})
    },
    normalize() {
      const fmt = (val) => {
        if (!val) return null
        if (typeof val === 'string') return val
        if (val.format) return val.format('YYYY-MM-DD HH:mm:ss')
        return val
      }
      return {
        userName: this.form.userName || '',
        operatorName: this.form.operatorName || '',
        startTime: fmt(this.form.startTime),
        endTime: fmt(this.form.endTime)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.role-record {
  .role-record-title {
    font-size: 30px;
    font-weight: 500;
    color: #131212;
  }
  .serach-warp {
    margin: 15px 0;
    .search-btn {
      color: #fff;
      background-color: rgba(232, 77, 17, 0.6);
      border-color: rgba(232, 77, 17, 0.6);
    }
  }
}
</style>
